export const isPresent = (value) => value && /\S/.test(value);
